import { useMutation, useQueryClient } from "@tanstack/react-query";
import { businessLicenseMutationApi } from "@/shared/api/business-license/mutation";
import { BuyerBusinessLicenseRequestBody } from "@/shared/api/business-license/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import useAppToasts from "@/features/line-sheet-sets/hooks/use-app-toasts";

// 바이어 사업자등록증 등록/교체 — POST 하나로 최초 등록과 교체를 모두 처리한다.
// 성공 안내 UI는 호출부가 담당한다.
const useUpdateBuyerBusinessLicense = () => {
  const { companyId } = useCompanyIdentity();
  const queryClient = useQueryClient();
  const { error } = useAppToasts({ id: "GLOBAL" });

  return useMutation({
    mutationFn: (body: BuyerBusinessLicenseRequestBody) =>
      businessLicenseMutationApi.updateBuyerBusinessLicense(
        companyId as number,
        body
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["buyer-business-license", companyId],
      });
    },
    onError: (err) => {
      error(err);
    },
  });
};

export default useUpdateBuyerBusinessLicense;
